// extracted by mini-css-extract-plugin
module.exports = {"header":"BJJ4p","logo":"RcNzi","background":"GA4sr","confirm":"_8a6lN","dialogue":"olhki"};